/**
 * Module for consuming, cacheing, and pooling datasource-manager end-points. Provides a Defer/Promise interface for handling repsonse and error events.
 * @name data-fetcher
 */

const {DataFetcher} = require('data-fetcher/data-fetcher');
const DataLoaderFetchRequest = require('./lib/DataLoaderFetchRequest');
const IsometricFetchRequest = require('./lib/IsometricFetchRequest');
const fetchConfigToRequestConfigAdapter = require('./lib/fetchConfigToRequestConfigAdapter');

class NodeDataFetcher extends DataFetcher {
    constructor (opts) {
        super(opts);
    }
}

module.exports = function nodeDataLoaderFetch (_dataLoader) {
    const opts = {
        FetchRequest: IsometricFetchRequest
    };
    // If dataLoader instance isn't passed in, we'll fallback to 
    // plain ismorphic fetch.
    // otherwise, leverage dataLoader
    if (_dataLoader) {
        DataLoaderFetchRequest.fetch = function dataLoaderFetch (url, fetchConfig, fetchRequest) {
            const dataLoaderConfig = fetchConfigToRequestConfigAdapter(fetchConfig);

            return _dataLoader.get({
                [fetchRequest.datasource.name]: url
            }, dataLoaderConfig);
        };
        // Attach DataLoaderFetchRequest to handle dataLoader request/response
        // specifics
        opts.FetchRequest = DataLoaderFetchRequest;
    }
    return new NodeDataFetcher(opts);
}
